import React from "react";
import { SVGAsset } from "res";
import "./styles.css";
/**
 * @function PromoInfoView 
 * @param {React.Component} icon Pass an icon into the component.
 * @param {STRING} title Pass the text for the promo title.
 * @param {STRING} description Pass the text for promo description.
 * @returns {React.Component}
 * @example
 * <div className="promo-container flex-container flex-horizontal align-center">
 *  <PromoInfoView icon={icon} title={title} description={description} />
 *  <PromoLinkView text="Some link" />
 * </div>
*/
export function PromoInfoView(props) {
    const icon = props.icon ?? <SVGAsset id="MagnifyingGlassIcon" className="magnifying-glass-icon"/>;
    const title = props.title ?? "[[title]]";
    const description = props.description ?? "";
    const titleDataPoint = props.dataPoint ? { "data-point" : props.dataPoint + "_Title" } : {};
    
    return(
      <div className="promo-info-view flex-width flex-container align-center">
          {icon}
          <div className="text-container flex-width">
            <div className="flex-container flex-horizontal">
              <h3 className="promo-title set-width" {...titleDataPoint}>{title}</h3>
              {props.activeBadge}
            </div>
            <div className="flex-container flex-horizontal space-between">
              <p className="promo-description gray-text flex-width">{description}</p>
              {props.children}
            </div>
          </div>
      </div>
    )
  }

export function ActiveBadge(props) {
  const dataPoint = props.dataPoint ? { "data-point" : props.dataPoint + "_Active_Badge" } : {};
  return(
    <div className="active-badge set-width flex-container flex-horizontal align-center">
      <SVGAsset id="StatusIndicatorCircleIcon" />
      <b { ...dataPoint }>Active</b>
    </div>
  );
}